import CacheGroup from '@/modules/common/enums/cache-group.ts';
import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';

export type CacheRemoveParams = {
  group?: string;
  key?: string;
};

export type CacheAddParams = {
  group?: string;
  key: string;
  value: unknown;
};

type CacheState = {
  values: Record<string, Record<string, unknown>>;
};

export const useCacheStore = defineStore(StoreId.Cache, {
  state: (): CacheState => ({
    values: {},
  }),
  getters: {
    get:
      (state) =>
      ({ group, key }: { group?: string; key: string }) =>
        state.values[group || CacheGroup.Common]?.[key],
  },
  actions: {
    add({ group, key, value }: CacheAddParams) {
      const groupKey = group || CacheGroup.Common;

      this.values = {
        ...this.values,
        [groupKey]: {
          ...this.values[groupKey],
          [key]: value,
        },
      };
    },
    remove({ group, key }: CacheRemoveParams) {
      const groupKey = group || CacheGroup.Common;

      const { [groupKey]: groupState, ...rest } = this.values;

      if (!key) {
        this.values = rest;
        return;
      }

      if (!groupState) {
        return;
      }

      const { [key]: _, ...groupRest } = groupState;

      this.values = {
        ...rest,
        [groupKey]: groupRest,
      };
    },
  },
});
